import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigate  as uNavigate} from 'react-router-dom'

import { useDispatchCart as uDispatchCart, useCart as uCart } from '../reducer/contextReducer'

export default function productCard(props) {
    const navigate=uNavigate()

    let dispatch = uDispatchCart()
    let data = uCart()
    
    let medprod = props.medProduct
    let ProdTitle = medprod.productTitle
    let ProdType = medprod.productType
    let medImg = medprod.productImage
    let medQuant = medprod.productQuantity
    let medCount = medprod.productCount
    let price = medprod.productAmount

    const handleDesc = () => {
        localStorage.setItem('prod_title',ProdTitle)
    }

    const handleAddToCart = async (e) => {
        e.preventDefault()
        if (localStorage.getItem('userEmail')) {
            let med = data.find(item => item.id === medprod._id)
            if (med) {
                await dispatch({ type: "UPDATE", id: medprod._id, productAmount: price, productQuantity: medQuant, productCount: medCount })
            } else {
                await dispatch({ type: "ADD", id: medprod._id, productImage: medprod.productImage, productTitle: medprod.productTitle, productQuantity: medQuant, productType: medprod.productType, productAmount: price, productCount: medCount })
            }            
        }
        else {
            alert('Login First')
            navigate('/login')
        }
            
        }

  return (
      <>  
          <div className="row row-cols-1 row-cols-md-2 g-4" style={{ objectFit: 'fill' }}>
              <div className="col">
                  <div className="card" >
                      <img style={{  height: '100px',objectFit:'fill' }} src={medImg.includes('http') ? medImg : `http://localhost:8000/public/images/${medImg}`} className="card-img-top" alt="..." />
                          <div className="card-body" >
                          <h5 className="card-title">{ProdTitle}</h5>
                          <p className="card-text">{medQuant} mg</p>
                          <p>{ProdType}</p>
                          <p className="price"><span>₹</span>{price}</p>
                          <Link style={{ textAlign: 'center', backgroundColor: 'orange', border: 'none', textDecoration: 'none', color: 'white' }} onClick={handleDesc} to='/productDetails'  >
                              View
                          </Link>
                      </div>
                      <button onClick={handleAddToCart} className="btn btn-success mb-3">Add To Cart</button>
                  </div>
              </div>
          </div>
    </> 
  )
}
